<template>
  <PopUpContents
    ref="popup"
    height="48rem"
  >
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="container-fluid p-3 bb-tooltip-wrapper bb-contents-dialog-body">
      <div class="col p-2">
        <!-- -------------------- -->
        <!--  row 1 - container   -->
        <!-- -------------------- -->
        <div class="row">
          <div class="bb-hdg mb-2 text-center bb-truncate-text">
            {{ container.name }}
          </div>
        </div>
        <!-- --------- -->
        <!--   row 2   -->
        <!-- --------- -->
        <div class="row mt-3 mb-3">
          <!-- -------------- -->
          <!--   size (r/o)   -->
          <!-- -------------- -->
          <div class="col form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-center"
                :value="container.container_size_long"
                id="size"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="size"
                >Size</label
              >
            </div>
          </div>
          <!-- ----------------------- -->
          <!--   container enc (r/o)   -->
          <!-- ----------------------- -->
          <div class="col form-group">
            <ToolTip
              :text="displayContainerEnc"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="formatEnc(container.enc)"
                  id="container_enc"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="container_enc"
                  >Container Enc
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
          <!-- --------------------- -->
          <!--   contents enc (r/o)   -->
          <!-- ---------------------- -->
          <div class="col form-group">
            <ToolTip
              :text="displayContentsEnc"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="formatEnc(overallContentsEnc)"
                  id="contents_enc"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="contents_enc"
                  >Contents Enc
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
          <!-- ------------------- -->
          <!--   total enc (r/o)   -->
          <!-- ------------------- -->
          <div class="col form-group">
            <ToolTip
              :text="displayTotEnc"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="formatEnc(container.enc + overallContentsEnc)"
                  id="tot_enc"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="tot_enc"
                  >Total Enc
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
        </div>
        <!-- --------- -->
        <!--   row 2   -->
        <!-- --------- -->
        <div class="row mt-3 mb-3">
          <!-- ------------------ -->
          <!--   capacity (r/o)   -->
          <!-- ------------------ -->
          <div class="col form-group">
            <ToolTip
              :text="displayCapacityEnc"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="formatEnc(container.container_capacity)"
                  id="capacity"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="capacity"
                  >Capacity Enc
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
          <!-- ----------------------- -->
          <!--   available enc (r/o)   -->
          <!-- ----------------------- -->
          <div class="col">
            <ToolTip
              :text="displayAvailableEnc"
              position="bottom"
            >
              <div class="form-group">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control text-center"
                    :value="
                      formatEnc(
                        container.container_capacity - overallContentsEnc,
                      )
                    "
                    id="avail_enc"
                    disabled
                  />
                  <label
                    class="bb-float-label optional"
                    for="avail_enc"
                    >Available Enc
                    <span class="bb-orange-circle"></span>
                  </label>
                </div>
              </div>
            </ToolTip>
          </div>
          <!-- ------------------------------ -->
          <!--  direct contents count (r/o)   -->
          <!-- ------------------------------ -->
          <div class="col form-group">
            <ToolTip
              :text="displayDirectCnt"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="container.contents_count_direct"
                  id="contents_count_direct"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="contents_count_direct"
                  >Direct Items
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
          <!-- -------------------------------------- -->
          <!--  total contents count (r/o)          -->
          <!--  (direct contents + nested child items) -->
          <!-- -------------------------------------- -->
          <div class="col form-group">
            <ToolTip
              :text="displayTotalCnt"
              position="bottom"
            >
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="totalContentsCount"
                  id="contents_count_total"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="contents_count_total"
                  >Total Items
                  <span class="bb-orange-circle"></span>
                </label>
              </div>
            </ToolTip>
          </div>
          <!-- ----------------- -->
          <!--   cancel button   -->
          <!-- ----------------- -->
          <div class="col form-group">
            <div
              class="btn-group special"
              role="group"
            >
              <!-- ------------ -->
              <!--    cancel    -->
              <!-- ------------ -->
              <button
                type="submit"
                @click="_cancel"
                class="btn btn-lg btn-warning"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <!-- --------- -->
        <!--   row 3   -->
        <!-- --------- -->
        <div
          v-if="this.parent_container"
          class="row mt-3 mb-3"
        >
          <div class="col-5 form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-left"
                :value="this.parent_container.name"
                id="parent_container"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="parent_container"
                >Parent Container</label
              >
            </div>
          </div>
        </div>
        <div
          v-else-if="this.attach_location"
          class="row mt-3 mb-3"
        >
          <div class="col-5 form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-left"
                :value="this.attach_location.name"
                id="attach_location"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="attach_location"
                >Attached Location</label
              >
            </div>
          </div>
        </div>
        <div
          v-else-if="this.worn_location"
          class="row mt-3 mb-3"
        >
          <div class="col-5 form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-left"
                :value="this.worn_location.name"
                id="worn_location"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="worn_location"
                >Worn Location</label
              >
            </div>
          </div>
        </div>
        <!-- --------- -->
        <!--   row 4   -->
        <!-- --------- -->
        <p class="bb-hdg mb-3">Contents</p>
        <p
          v-if="footerMessage"
          class="bb-error-wrap mt-2 mb-3 bb-contents-dialog-footer-message"
        >
          *** {{ footerMessage }} ***
        </p>
        <div class="row mt-3 mb-3">
          <div class="form-group">
            <div class="form-floating">
              <!-- v-select works with "options" as the control's API,
                 but each element in contents is a rendered item -->
              <v-select
                :options="contents"
                :get-option-label="formatItemLabel"
                :dropdown-should-open="dropdownShouldOpen"
                class="form-control contents-dialog-select bb-linked-values-dropdown"
                placeholder="search..."
                id="item"
              >
                <!-- search row -->
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>

                <!-- dropdown options (scoped slot from vue-select) -->
                <!-- slot props are the option object itself, not { option } -->
                <template #option="item">
                  <div
                    class="contents-option"
                    :class="
                      item.storage
                        ? 'contents-option-storage'
                        : 'contents-option-non-storage'
                    "
                  >
                    {{ formatItemLabel(item) }}
                  </div>
                </template>

                <!-- selected value in the input -->
                <template #selected-option="item">
                  <span
                    class="contents-option-selected"
                    :class="
                      item.storage
                        ? 'contents-option-storage'
                        : 'contents-option-non-storage'
                    "
                  >
                    {{ formatItemLabel(item) }}
                  </span>
                </template>
              </v-select>
              <label
                class="bb-float-label"
                for="item"
                >Item</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'
import ToolTip from '../components/ToolTip.vue'

export default {
  name: 'ContentsDialog',
  components: {
    PopUpContents,
    ToolTip,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    container: {},
    parent_container: null,
    attach_location: null,
    worn_location: null,
    character_items: [],
    contents: [],
    resolvePromise: undefined,
    rejectPromise: undefined,
    search: '',
    footerMessage: '',
  }),
  //=====================================================================
  // methods
  //---------
  methods: {
    // -------------------------------------------------------------------
    // generic formatter for ENC-like numeric fields
    //---------
    formatEnc(value) {
      if (value === null || value === undefined) return ''
      const num = typeof value === 'string' ? parseFloat(value) : value
      if (Number.isNaN(num)) return ''
      return num.toFixed(2)
    },
    // -------------------------------------------------------------------
    show(opts = {}) {
      // passed in parms
      this.container = opts.container
      this.character = opts.character
      this.character_items = opts.character.items
      this.footerMessage = opts.footerMessage || ''
      console.log('SHOW container = ', this.container)
      // console.log("SHOW character_items =", this.character_items);

      // get parent location
      if (this.container) {
        // get container
        if (this.container.container != null) {
          this.parent_container =
            this.character_items.find(
              (ci) => ci.id === this.container.container,
            ) || null

          // get attach location
        } else if (this.container.attach_location != null) {
          this.attach_location =
            this.character_items.find(
              (ci) => ci.id === this.container.attach_location,
            ) || null

          // get worn location
        } else if (this.container.worn_location != null) {
          const getRace = this.$store.getters['races/getRaceByName']
          const race =
            typeof getRace === 'function'
              ? getRace(this.character.race_name)
              : []
          this.worn_locations = Array.isArray(race?.worn_item_locations)
            ? race.worn_item_locations
            : []
          this.worn_location =
            this.worn_locations.find(
              (ci) => ci.id === this.container.worn_location,
            ) || null
          console.log('SHOW worn_location = ', this.worn_location)
        }
      }

      // load contents for this container
      this.contents = this.getContents(this.character_items)

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    // -------------------------------------------------------------------
    dropdownShouldOpen() {
      // always allow the dropdown to open when the control is focused/clicked
      return true
    },
    // -------------------------------------------------------------------
    selectItem(item) {
      console.log('ContentsDialog selectItem: item=', item)
    },
    // -------------------------------------------------------------------
    getContents(character_items) {
      // console.log('getContents: character_items=', character_items)

      const allItems = Array.isArray(character_items) ? character_items : []
      const results = []

      // walk direct contents and all nested child items, tracking depth so we
      // can indent nested children in the dropdown
      const walk = (containerId, ancestors = [], depth = 0) => {
        const direct = allItems.filter((ci) => ci.container === containerId)
        // within a given parent container, show non-storage items first,
        // then storage containers
        const ordered = [...direct].sort((a, b) => {
          const aIsStorage = a.storage === true ? 1 : 0
          const bIsStorage = b.storage === true ? 1 : 0
          return aIsStorage - bIsStorage
        })

        ordered.forEach((ci) => {
          // base ENC is always the item's own enc
          let enc = ci.enc
          // if this is a storage item with contents, show its total ENC (own + contents)
          const hasContents = (ci.contents_enc ?? 0) > 0
          if (ci.storage === true && hasContents) {
            enc = ci.tot_enc != null ? ci.tot_enc : ci.enc
          }

          const baseName =
            (ci.display_name && ci.display_name !== ''
              ? ci.display_name
              : null) ||
            (ci.name != null ? ci.name : null) ||
            (ci.item && (ci.item.display_name || ci.item.name)) ||
            ''

          const pathNames = [...ancestors, baseName].filter(Boolean)

          // depth is how far this item is from the root container;
          // root children are depth 1, their children depth 2, etc.
          const childDepth = depth + 1

          results.push({
            id: ci.id,
            name: baseName,
            depth: childDepth,
            enc,
            tally_qty: ci.tally_qty,
            // for containers, include how many child items they hold
            storage: ci.storage,
            contents_count_direct: ci.contents_count_direct,
          })

          // recurse into child containers to include their nested contents
          if (ci.storage === true) {
            walk(ci.id, pathNames, childDepth)
          }
        })
      }

      if (this.container && this.container.id != null) {
        const rootName =
          (this.container.display_name && this.container.display_name !== ''
            ? this.container.display_name
            : null) ||
          (this.container.name != null ? this.container.name : null) ||
          ''
        // root children start at depth 1
        walk(this.container.id, [rootName], 0)
      }

      // console.log('contents (mapped): ', results)
      return results
    },
    // -------------------------------------------------------------
    // format item label (dropdown options)
    // -------------------------------------
    formatItemLabel(item) {
      if (!item) return ''
      // console.log('formatItemLabel: item=', item)
      const qty = item.tally_qty
      const depth =
        typeof item.depth === 'number' && item.depth > 0 ? item.depth : 1

      const indentLevels = depth - 1
      // slightly increase indentation per nesting level
      const indent = indentLevels > 0 ? '\u00A0'.repeat(indentLevels * 5) : ''

      // base label: name + ENC (+ tally if >1)
      let label =
        qty != null && qty > 1
          ? `${item.name} - Enc (${item.enc}) x ${qty}`
          : `${item.name} - Enc (${item.enc})`

      // if this item is a storage item with child contents, append child count
      if (
        item.storage === true &&
        item.contents_count_direct != null &&
        item.contents_count_direct > 0
      ) {
        const childWord = item.contents_count_direct === 1 ? 'item' : 'items'
        label += ` [${item.contents_count_direct} ${childWord}]`
      }

      // prepend indentation so nested items visually sit under their container
      return `${indent}${label}`
    },
    // -------------------------------------------------------------------
    // cancel
    //--------
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise()
    },
  },
  //=====================================================================
  // computed
  //----------
  computed: {
    displayContainerEnc() {
      return `Enc of this container`
    },
    displayCapacityEnc() {
      return `How much enc this container can hold`
    },
    displayContentsEnc() {
      return `Total enc of all contents within this container (incl. nested items/ quantities)`
    },
    displayDirectCnt() {
      return `Count of items in this container (NOT incl. nested items)`
    },
    displayTotalCnt() {
      return `Count of ALL items in this container (incl. nested items)`
    },
    displayAvailableEnc() {
      return `Container Capacity (${this.formatEnc(this.container.container_capacity)}) - Contents Enc (${this.formatEnc(this.overallContentsEnc)})`
    },
    displayTotEnc() {
      return `Container Enc (${this.formatEnc(this.container.enc)}) + Contents Enc (${this.formatEnc(this.overallContentsEnc)})`
    },
    // overall contents ENC, based on the dialog's view of direct children
    // (each storage child contributes its total ENC, including its own contents)
    overallContentsEnc() {
      if (!this.container) {
        return 0
      }

      if (!Array.isArray(this.contents) || this.contents.length === 0) {
        const baseEnc =
          this.container && typeof this.container.contents_enc === 'number'
            ? this.container.contents_enc
            : 0
        return baseEnc
      }

      // depth 1 entries are the direct contents of this.container
      const direct = this.contents.filter((item) => item && item.depth === 1)

      const totalEnc = direct.reduce((sum, item) => {
        const num =
          typeof item.enc === 'string' ? parseFloat(item.enc) : item.enc
        if (Number.isNaN(num)) {
          return sum
        }
        return sum + num
      }, 0)

      return totalEnc
    },
    // total contents = direct contents_count_direct + sum of child counts for any
    // storage items listed in this.contents
    totalContentsCount() {
      const base =
        this.container &&
        typeof this.container.contents_count_direct === 'number'
          ? this.container.contents_count_direct
          : 0

      if (!Array.isArray(this.contents) || this.contents.length === 0) {
        return base
      }

      const nested = this.contents.reduce((sum, item) => {
        if (
          item &&
          item.storage === true &&
          typeof item.contents_count_direct === 'number' &&
          item.contents_count_direct > 0
        ) {
          return sum + item.contents_count_direct
        }
        return sum
      }, 0)

      return base + nested
    },
  },
}
</script>

<style scoped>
.bb-contents-dialog-body {
  padding-bottom: 1rem;
}

.bb-contents-dialog-footer-message {
  text-align: left;
  white-space: pre-line;
}

/* limit dropdown height and add bottom padding just for this dialog */
:deep(.contents-dialog-select .vs__dropdown-menu) {
  max-height: 25rem;
  overflow-y: auto;
  /* override global vue-select offset so menu aligns with the control */
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0.5rem;
}

/* preserve exact casing for item labels (avoid capitalising 'x') */
:deep(.contents-dialog-select .vs__dropdown-menu),
:deep(.contents-dialog-select .vs__selected),
:deep(.contents-dialog-select .vs__search) {
  text-transform: none;
}

/* custom option styling for storage vs non-storage items */
:deep(.contents-dialog-select .contents-option) {
  padding-top: 0.1rem;
  display: flex;
  align-items: center;
  font-size: 0.9em;
}

/* storage items: normal/light text */
:deep(.contents-dialog-select .contents-option-storage) {
  color: #ffffff;
}

/* non-storage items: greyed out */
:deep(.contents-dialog-select .contents-option-non-storage) {
  color: #9ca3af;
}

/* storage items: normal/light text */
:deep(.contents-dialog-select .contents-option-storage),
:deep(
  .contents-dialog-select .contents-option-selected.contents-option-storage
) {
  color: #ffffff;
}

/* non-storage items: greyed out */
:deep(.contents-dialog-select .contents-option-non-storage),
:deep(
  .contents-dialog-select .contents-option-selected.contents-option-non-storage
) {
  color: #7d7c7c;
}
</style>
